import { Icon, Protected } from '@cotera/client/app/components';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@cotera/client/v0/components/ui/sidebar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@cotera/client/v0/components/ui/dropdown-menu';
import { LifeBuoy, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSettingsModal } from '../../settings/settings-modal';
import { useWhoami } from '@cotera/client/app/stores/org';

const MOBILE_SIDEBAR_COLLAPSE_DELAY_MS = 200;

export function Footer() {
  const { openSettings } = useSettingsModal();
  const { isMobile, openMobile, setOpenMobile } = useSidebar();
  const org = useWhoami((s) => s.org);

  const handleOpenSettings = () => {
    if (isMobile && openMobile) {
      setOpenMobile(false);
      window.setTimeout(() => {
        openSettings();
      }, MOBILE_SIDEBAR_COLLAPSE_DELAY_MS);
      return;
    }

    openSettings();
  };

  return (
    <SidebarMenu className="flex-shrink-0 py-2">
      <SidebarMenuItem>
        <SidebarMenuButton
          className="cursor-pointer"
          onClick={handleOpenSettings}
        >
          <Settings /> Settings
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton
          className="cursor-pointer"
          onClick={() => {
            window.Pylon?.('show');
          }}
        >
          <LifeBuoy /> Support
        </SidebarMenuButton>
      </SidebarMenuItem>
      <Protected scopes={[['use', 'superadmin']]}>
        <SidebarMenuItem>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <SidebarMenuButton className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground cursor-pointer">
                <Icon icon="ghost" /> Superadmin Tools
              </SidebarMenuButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="start"
              side="right"
              className="min-w-48"
            >
              <DropdownMenuItem asChild>
                <Link
                  to={`/${org.slug}/atc-visibility`}
                  className="flex items-center gap-2 w-full"
                >
                  <Icon icon="chart-bar" />
                  <span>ATC Visibility</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link
                  to={`/${org.slug}/bill-engineering-hours`}
                  className="flex items-center gap-2 w-full"
                >
                  <Icon icon="dollar" />
                  <span>Bill Engineering Hours</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link
                  to={`/${org.slug}/materializations`}
                  className="flex items-center gap-2 w-full"
                >
                  <Icon icon="table" />
                  <span>Materializations</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link
                  to={`/${org.slug}/artifacts`}
                  className="flex items-center gap-2 w-full"
                >
                  <Icon icon="document" />
                  <span>Artifacts</span>
                </Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </SidebarMenuItem>
      </Protected>
    </SidebarMenu>
  );
}
